"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RavensCallAbilityHandler = exports.RavensCallActorAbilityFactory = exports.RavensCallAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const Resurrect_1 = require("../../core/effects/core/Resurrect");
const Registries_1 = require("../../core/state/Registries");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class RavensCallAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.RavensCall;
        this.__typeName = "RavensCall";
    }
}
exports.RavensCallAbilityArgs = RavensCallAbilityArgs;
let RavensCallActorAbilityFactory = class RavensCallActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("RavensCall", "OneDeadAllies", 4);
    }
};
RavensCallActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("RavensCall")
], RavensCallActorAbilityFactory);
exports.RavensCallActorAbilityFactory = RavensCallActorAbilityFactory;
let RavensCallAbilityHandler = class RavensCallAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [selectedAlly] = ability.args.target.actorIds;
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                sequence
                    .push(core_1.AnimateCharacterVfxStepArgs.Resurrected(selectedAlly))
                    .push(new core_1.CharacterSoundEffectVfxStepArgs(selectedAlly, "resurrected"))
                    .push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedAlly, "chest"), "PinkGlyph"));
                container.applyBuff({
                    creatorId: ability.invokerId,
                    targetId: selectedAlly,
                    effect: new Resurrect_1.ResurrectEffectArgs("RavensCall"),
                    duration: Duration_1.Duration.Instant,
                    sequence: sequence.pushSequence("sequential"),
                });
            }
        });
    }
};
RavensCallAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.RavensCall)
], RavensCallAbilityHandler);
exports.RavensCallAbilityHandler = RavensCallAbilityHandler;
